// extracted by mini-css-extract-plugin
module.exports = {"attributes":"ModuleAttributes_attributes__Jf_jq","attribute":"ModuleAttributes_attribute__8GFgY","alignIconTop":"ModuleAttributes_alignIconTop__YAjn9"};